<template>
  <layout-main-inner title="售后工单">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="createOutstock(1)">新建售后工单</el-button>
        <!-- <el-dropdown>
          <el-button type="primary">
            新建售后工单<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="createOutstock(1)">销售订单</el-dropdown-item>
            <el-dropdown-item @click.native="createOutstock(2)">调拨单</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </template>
      <template slot="form">
        <!-- <el-select
          v-model="config.status"
          placeholder="请选择状态"
          @change="fetchList">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->
        <el-input
          v-model="config.receiverName"
          placeholder="请输入收件人"
          clearable=""
          style="width: 160px">
        </el-input>
        <el-input
          v-model="config.receiverPhone"
          placeholder="请输入收件人号码"
          clearable=""
          style="width: 160px;margin-left: 10px;">
        </el-input>
        <el-input
          v-model="config.dealOrderCode"
          clearable=""
          placeholder="请输入订单号"
          style="width: 200px;margin-left: 10px">
        </el-input>
        <el-input
          v-model="config.postSaleOrderNumber"
          placeholder="请输入售后工单号"
          clearable=""
          style="width: 200px;margin-left: 10px;">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          fixed="left"
          label="售后工单号"
          width="160">
          <template slot-scope="{row}">
            <link-route>
              <span @click="linkto(row)">{{ row.postSaleOrderNumber }}</span>
            </link-route>
          </template>
        </el-table-column>
        <el-table-column
          label="订单编号"
          width="160"
          prop="dealOrderCode"></el-table-column>
        <el-table-column
          label="售后类型"
          width="80"
          :resizable="false"
          prop="sourceBillType">
          <template slot-scope="{row}">
            {{ row.sourceBillType === 2 ? '调拨' : '销售' }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="140"
          label="收件人">
          <template slot-scope="{row}">
            <span v-if="row.receiverName">{{ row.receiverName }}</span>
            <span>-</span>
            <span v-if="row.receiverPhone">{{ row.receiverPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200"
          label="图片信息">
          <template slot-scope="{row}">
            <image-list
              v-if="row.proofImageList.length > 0"
              :list="row.proofImageList" />
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="reason"></el-table-column>
        <el-table-column
          width="90"
          label="售后类别">
          <template slot-scope="{row}">
            <span v-if=" row.type === 2">退货</span>
            <span v-if=" row.type === 3">换货</span>
            <span v-if=" row.type === 4">补发货</span>
            <span v-if=" row.type === 9">其他</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="90">
          <template slot-scope="{row}">
            {{ row.status | aftersaleStatus() }}
          </template>
        </el-table-column>
        <el-table-column
          width="70"
          label="明细">
          <template slot-scope="{row}">
            <el-popover
              v-if="row.details && row.details.length > 0"
              placement="right"
              trigger="hover">
              <el-table
                border=""
                :data="row.details">
                <el-table-column
                  width="180"
                  property="productName"
                  label="商品名称"></el-table-column>
                <el-table-column
                  width="80"
                  property="productNumber"
                  label="商品编码"></el-table-column>
                <el-table-column
                  property="goodsCount"
                  label="退货数量">
                  <template slot-scope="scope">{{ scope.row.goodsCount }} {{ scope.row.measureUnit | measureUnitName() }}</template>
                </el-table-column>
                <el-table-column
                  property="returnedGoodsCount"
                  label="已退数量">
                  <template slot-scope="scope">{{ scope.row.returnedGoodsCount }} {{ scope.row.measureUnit | measureUnitName() }}</template>
                </el-table-column>
              </el-table>
              <el-link
                slot="reference"
                style="font-size: 12px"
                type="primary">查看</el-link>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="140">
          <template slot-scope="{row}">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          :resizable="false"
          width="105">
          <template slot-scope="{row}">
            <!-- <el-button v-if="row.status === 0"
              type="warning"
              @click.native="addextra(row)">
              创建补单
            </el-button> -->
            <el-dropdown v-if="row.status === 0">
              <el-button type="warning">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="addextra(row)">创建补单</el-dropdown-item>
                <el-dropdown-item @click.native="closepostsaleorder(row)">关闭</el-dropdown-item>
                <!-- <el-dropdown-item @click.native="outdetail(row)">完成</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <order-select-modal
      ref="order"
      :options="{outTypeList:[1,3],outStatusList:[1,2]}"
      :callback="getoutstockorder" />
    <transfer-select-modal
      ref="transfer"
      :callback="getoutstockorder1" />
    <after-sales-modal
      ref="after"
      :callback="fetchList" />
  </layout-main-inner>
</template>

<script>
// import clonedeep from 'lodash.clonedeep'
import { mapState } from 'vuex'
import ImageList from '../../components/image-list.vue'
import OrderSelectModal from '../goodsreturn/busi/order-select-modal.vue'
import TransferSelectModal from '../goodsreturn/busi/transfer-select-modal.vue'
import AfterSalesModal from './after-sales-modal.vue'

export default {
  name: 'AfterSalesList',
  components: { OrderSelectModal, AfterSalesModal, TransferSelectModal, ImageList },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        dealOrderCode: '',
        postSaleOrderNumber: '',
        receiverName: '',
        receiverPhone: ''
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    addextra(row) {
      this.$store.dispatch('outstock/getsaleslist', {
        payload: {
          code: row.dealOrderCode
        },
        success: (res) => {
          const records = res.data.data.records
          if (records.length === 0) {
            this.$message.error('订单不存在')
            return
          }
          const id = records[0].id
          this.$router.push(`/aftersales-order-create?salesOrderId=${id}&code=${row.dealOrderCode}`)
        },
        fail: () => {}
      })
    },
    linkto(row) {
      if (row.sourceBillType === 1) {
        this.$store.dispatch('outstock/getsaleslist', {
          payload: {
            code: row.dealOrderCode
          },
          success: (res) => {
            const records = res.data.data.records
            if (records.length === 0) {
              this.$message.error('订单不存在')
              return
            }
            const id = records[0].id
            this.$router.push(`/orders-detail?salesOrderId=${id}&code=${row.dealOrderCode}&activeName=4`)
          },
          fail: () => {}
        })
      }
      if (row.sourceBillType === 2) {
        this.$store.dispatch('outstock/allocatelist', {
          payload: {
            code: row.omsAllocateOrderCode
          },
          success: (res) => {
            const id = res.data.data.records[0].id
            this.$router.push(`/transfer-stock-detail?allocateOrderId=${id}&code=${row.dealOrderCode}&activeName=4`)
          },
          fail: () => {}
        })
      }
    },
    createOutstock(type) {
      if (type === 1) {
        this.$refs.order.fetch()
      } else {
        this.$refs.transfer.fetch()
      }
      // this.$refs.order.fetch()
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    getoutstockorder(id) {
      this.$store.dispatch('outstock/salesdetail', {
        payload: {
          salesOrderId: id
        },
        success: res => {
          // this.toggleModal(false)
          // this.callback && this.callback(res.data.data)
          this.$refs.after.init(res.data.data)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getoutstockorder1(id) {
      this.$store.dispatch('outstock/allocatedetail', {
        payload: {
          allocateOrderId: id
        },
        success: res => {
          // this.toggleModal(false)
          // this.callback && this.callback(res.data.data)
          this.$refs.after.init(res.data.data)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('goodsreturn/getpostsaleorders', {
        payload: {
          ...this.config
          // status: this.config.status !== null ? [this.config.status] : null
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              proofImageList: i.proofImage ? i.proofImage.split(',') : []
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    closepostsaleorder(row) {
      this.$confirm(`该操作将关闭该售后工单, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('goodsreturn/closepostsaleorder', {
          payload: {
            postSaleOrderId: row.postSaleOrderId
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    }
  }
}
</script>

